import { InternationalizationEnvironment } from '../../app/core/configuration';

declare type availableLanguages =
  | 'spanish'
  | 'english'
  | 'french'
  | 'catalan'
  | 'galego'
  | 'euskara'
  | 'dutch'
  | 'italian'
  | 'german'
  | 'portoguese';
export const languages: Record<availableLanguages, string> = {
  spanish: 'es-ES',
  english: 'en-GB',
  french: 'fr-FR',
  italian: 'it-IT',
  catalan: 'ca-ES',
  galego: 'gl-ES',
  euskara: 'eu-ES',
  dutch: 'nl-NL',
  german: 'de-DE',
  portoguese: 'pt-PT'
};
export const currency = 'EUR';

export const internationalization: InternationalizationEnvironment = {
  defaultLanguage: languages.spanish,
  defaaultCurrency: currency,
  languages: [
    languages.french,
    languages.english,
    languages.spanish,
    languages.catalan,
    languages.galego,
    languages.euskara,
    languages.dutch,
    languages.italian,
    languages.german,
    languages.portoguese
  ]
};
